export default __webpack_public_path__ + "static/media/without-operators.2a4472c7.svg";